import { useToastNotifications } from "../../../utils/toastUtils";

export const useOpenFile = () => {
  const { showErrorToast } = useToastNotifications();
  const downloadFile = async (fileUrl: string, fileName: string) => {
    try {
      const response = await fetch(fileUrl);
      if (!response.ok) {
        throw new Error("Erreur lors du téléchargement du fichier");
      }
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch {
      showErrorToast({
        title: "Téléchargement",
        description: "Erreur lors du téléchargement du fichier",
      });
    }
  };

  return { downloadFile };
};

function base64ToBlob(base64: string, contentType = ""): Blob {
  // si c’est un dataURL, on extrait le mimeType et la partie base64
  const dataUrlMatch = base64.match(/^data:([^;]+);base64,(.*)$/);
  let b64 = base64;
  let mime = contentType;

  if (dataUrlMatch) {
    mime = dataUrlMatch[1] || contentType;
    b64 = dataUrlMatch[2];
  }

  const byteChars = atob(b64);
  const byteNumbers = new Array(byteChars.length);
  for (let i = 0; i < byteChars.length; i++) {
    byteNumbers[i] = byteChars.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: mime || "application/octet-stream" });
}

export const useOpenFileBase64 = () => {
  const { showErrorToast } = useToastNotifications();

  /**
   * Télécharge un fichier à partir d'une chaîne base64.
   * @param base64  soit une data URL (ex: "data:application/pdf;base64,....")
   *                soit le base64 pur ("JVBERi0xLjQKJ...").
   * @param fileName nom du fichier à sauvegarder (ex: "facture.pdf")
   * @param contentType optionnel si base64 n'est pas une data URL (ex: "application/pdf")
   */
  const downloadFileFromBase64 = async (
    base64: string,
    fileName: string,
    contentType?: string,
  ) => {
    try {
      const blob = base64ToBlob(base64, contentType);
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(blobUrl);
    } catch {
      showErrorToast({
        title: "Téléchargement",
        description: "Erreur lors du téléchargement du fichier",
      });
    }
  };

  return { downloadFileFromBase64 };
};
